import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  closePosSession,
  openSessionInfo,
} from "../../Redux/Action/loginAction";
import { useTranslation } from "react-i18next";
import CashIn_Modal from "./CashIn_Modal";
import { drop_arrow_black } from "../../assets";
import axiosInstance from "../../AxiosInstance";
import { URLS } from "../../API/API endpoints";
import { setCloseSession } from "../../Redux/Action/sessionActions";
import { toast } from "react-toastify";
import { detectWebDeviceType } from "../../utils";
import AlphaNumericKeyboardModal from "./AlphaNumericKeyboardModal";
import { logButtonClick } from "../../API/API Functions/ProductRequest_API";
import i18next from "i18next";
import { Select } from "antd";
const { Option } = Select;

const LoadingSpinner = () => {
  return (
    <div className="fixed top-0 left-0 w-full h-full flex justify-center items-center z-50 bg-black bg-opacity-50">
      <div className="spinner">
        <span className="me-2.5 "></span>
        <span className="me-2.5 "></span>
        <span className="me-2.5 "></span>
      </div>
    </div>
  );
};



function InputField({
  label,
  placeholder,
  value,
  onChange,
  type = "text",
  onEnterPress,
  inputRef,
  readOnly,
  onFocus,
  focused,
}) {
  const deviceType = detectWebDeviceType();
  const { t, i18n } = useTranslation();

  const handleKeyPress = (e) => {
    if (e.key === "Enter" && typeof onEnterPress === "function") {
      e.preventDefault();
      onEnterPress();
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && typeof onEnterPress === "function") {
      e.preventDefault();
      onEnterPress(); // Triggers handleConfirm
    }
  };

  return (
    <>
      <div className="mt-9 font-medium w-full max-md:max-w-full">{t(label)}</div>
      <div
        className={`flex border w-full rounded-xl overflow-hidden justify-center items-start transition-colors duration-200 ${i18n.language === "ar" ? "flex-row-reverse" : ""
          }
           ${deviceType === "tablet" && focused ? "" : ""}`} // ✅ Tablet-only blue border
      >
        {label === "Amount" && (
          <span className="pl-3 py-3 bg-white  text-black max-md:pe-3">
            EGP
          </span>
        )}
        <input
          ref={inputRef}
          type={type}
          placeholder={t(placeholder)}
          value={value}
          readOnly={readOnly}
          onFocus={onFocus}
          style={{
            direction: "ltr",
            caretColor:  undefined,
          }}
          onChange={(e) => onChange(e.target.value)}
          // onKeyPress={handleKeyPress}
          onKeyDown={handleKeyDown}
          onBlur={(e) => {
            if (onChange) {
              onChange(e.target.value);
            }
          }}
          className="p-3 bg-white rounded-xl text-left border border-neutral-400 border-opacity-50 border-solid  max-md:pr-5 max-md:max-w-full w-full focus:outline-none focus:border-2px"
        />
      </div>
    </>
  );
}

const CloseSessionModal = ({ closeModal, handleClose }) => {
  const { t, i18n } = useTranslation();

  const deviceType = detectWebDeviceType();
  const [sessionDetail, setSessionDetail] = useState();
  const [diffValue, setDiffValue] = useState();
  const [change, setChange] = useState();
  const [countedCash, setcountedCash] = useState(0);
  const [checked, setChecked] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const dispatch = useDispatch();
  const userData = useSelector((state) => state?.login?.user?.result);
  const [showCashInModal, setShowCashInModal] = useState(false); // State to control cash in modal visibility
  const [showSettleOptions, setShowSettleOptions] = useState(false);
  const [reason, setReason] = useState("");
  const [processing, setProcessing] = useState(false); // Add this state
  const draftOrders = useSelector((state) => state.draftOrders.draftOrders);
  // const showDash = useSelector(
  //   (state) => state?.login?.user?.result?.is_dashboard_show
  // );
    const [expenseTypes, setExpenseTypes] = useState([]);
  const [expenseType, setExpenseType] = useState("");
  const [loadingTypes, setLoadingTypes] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

    const showDash = useSelector(
      (state) => state?.permissionReducer?.permissions?.is_dashboard_show
    );
   const reasonRef = useRef("");
    const reasonInputRef = useRef(null);

  const [showSettle, setShowSettle] = useState(false);
  const [unpaid, setUnpaid] = useState(false);
  const [showKeyboard, setShowKeyboard] = useState(false);
  const [keyboardMode, setKeyboardMode] = useState("numeric"); // or "alphanumeric"
  const [focusedField, setFocusedField] = useState(""); // 'amount' or 'reason'
  const [cashOut, setCashOut] = useState(change);
  const countedCashRef = useRef(null);

  useEffect(() => {
    getData();
    fetchExpenseTypes();
  }, []);


   const fetchExpenseTypes = async () => {
    try {
      setLoadingTypes(true);
      const res = await getExpenseTypes(userData?.company_id);
      const types = res?.result?.expense_types?.map((type) => type.name) || [];
      setExpenseTypes(types);
      setLoadingTypes(false);
    } catch (err) {
      console.error(err);
      setLoadingTypes(false);
    }
  };

    const getExpenseTypes = async (company_id) => {
    try {
      let lang = i18n.language;

      if (lang === "ar") {
        lang = "ar";
      } else if (lang === "en") {
        lang = "en_US";
      }

      const payload = { company_id, lang };
      const response = await axiosInstance.post(
        URLS.GET_EXPENSE_TYPES,
        payload
      );

      return response.data;
    } catch (error) {
      return error;
    }
  };

  const getData = async () => {
    try {
      setLoading(true);
      const response = await dispatch(
        openSessionInfo(userData?.user_id, userData?.company_id)
      );
      console.log("Session data response", response);

      setSessionDetail(response);
      setChange(response?.cash_difference);
      setDiffValue(response?.cash_difference);
      if (response?.is_unpaid_order === true) {
        setUnpaid(true);
      } else {
        setUnpaid(false);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
      dispatch(setCloseSession(true));
      // localStorage.setItem("closeSession", true);
    }
  };

  // console.log("UNPAID", unpaid);

  const handleCloseSession = async (overrideReason) => {
console.log('overrideReason==>',overrideReason);

      const finalReason = overrideReason ?? reason;

    if((!finalReason || finalReason == '' || finalReason?.trim() === "") && showSettleOptions){
       toast.error(
        t("Reason is required.")
      );
      return;
    }

    if (unpaid) {
      toast.error(
        t("There are unpaid orders in the session please collect the payment.")
      );
      return;
    }

    if (draftOrders?.length > 0) {
      toast.error(
        t("There are draft orders in the session please discard them.")
      );
      return;
    }
    setLoading(true);
    setIsButtonDisabled(true);

    try {
      if (showSettleOptions) {
        const cashOutResponse = await axiosInstance.post(URLS.CASH_IN_OUT, {
          session_id: userData?.session_id,
          type: "cash_out",
          amount: cashOut,
          reason: reason,
          is_refund_with_new: false,
          is_credit_order: false,
          lang: i18next.language === "ar" ? "ar_001" : "en_US",

        });

        if (cashOutResponse?.data?.result?.status_code === 200) {
          const closeSessionResponse = await dispatch(
            closePosSession({
              session_id: userData?.session_id,
              diff_amount: 0,
              // counted_amount: countedCash,
              counted_amount:
                change === 0 ? sessionDetail?.cash_difference : countedCash,
              is_accept: checked,
            })
          );

          if (closeSessionResponse?.result?.status === 200) {
            // handleClose();
            // logButtonClick(userData?.user_id, userData?.company_id, "Close Session")
            await handleClose();
          }
        } else {
          console.error("Cash out operation failed.");
        }
      } else {
        const closeSessionResponse = await dispatch(
          closePosSession({
            session_id: userData?.session_id,
            diff_amount: 0,
            counted_amount: countedCash,
            is_accept: checked,
          })
        );
        // console.log("closeSessionResponse", closeSessionResponse);

        if (closeSessionResponse?.result?.status === 200) {
          // handleClose();
          await handleClose();
        }
      }
    } catch (err) {
      console.error("Error:", err);
    } finally {
      setLoading(false);
      setIsButtonDisabled(false);
    }
  };

  const handleDiffChange = (value) => {
    let change = parseFloat((diffValue + Number(value))?.toFixed(2));
    setcountedCash(value);
    setChange(change);
    if(change == 0){
      setShowSettleOptions(false)
    }
  };

  const handleEnterKeyPress = (e) => {
    if (e.key === "Enter") {
      if (!countedCash || (change !== 0 && !showSettleOptions)) {
        e.preventDefault();
      } else if (!processing) {
        setProcessing(true);
        handleCloseSession().finally(() => setProcessing(false));
      }
    }
  };

  useEffect(() => {
    const handleKeyDown = (e) => {
      // Normalize the key input for consistent handling
      const normalizedKey =
        e.key === "Escape"
          ? "Escape"
          : e.key === "ArrowUp"
            ? "ArrowUp"
            : e.shiftKey
              ? "Shift"
              : e.key;

      if (normalizedKey === "Escape") {
        e.preventDefault();
        closeModal();
        localStorage.setItem("eKeyPressed", false);
        // localStorage.setItem("closeSession", false)
        dispatch(setCloseSession(false));
      } else if (normalizedKey === "Shift") {
        e.preventDefault();
        setShowSettleOptions((prev) => !prev); // Toggle the state
      } else if (normalizedKey === "ArrowUp") {
        e.preventDefault();
        setShowSettleOptions((prev) => prev); // Ensure state consistency
        if (countedCashRef.current) {
          countedCashRef.current.focus();
        }
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  useEffect(() => {
    if (showSettleOptions) {
      setCashOut(change);
    }
  }, [showSettleOptions, change]);

  const handleCloseSessionForRestrictedUser = async () => {
   

    if (unpaid) {
      toast.error(
        t("There are unpaid orders in the session please collect the payment.")
      );
      return;
    }

    if (draftOrders?.length > 0) {
      toast.error(
        t("There are draft orders in the session please discard them.")
      );
      return;
    }
    setLoading(true);
    setIsButtonDisabled(true);

    try {
      if (change !== 0) {
        const cashOutResponse = await axiosInstance.post(URLS.CASH_IN_OUT, {
          session_id: userData?.session_id,
          type: change > 0 ? "cash_in" : "cash_out",
          amount: change,
          reason: change > 0 ? "extra-cash" : "less-cash",
          is_refund_with_new: false,
          is_credit_order: false,
          lang: i18next.language === "ar" ? "ar_001" : "en_US",

        });

        if (cashOutResponse?.data?.result?.status_code === 200) {
          const closeSessionResponse = await dispatch(
            closePosSession({
              session_id: userData?.session_id,
              diff_amount: 0,
              // counted_amount: countedCash,
              counted_amount: countedCash,
              is_accept: checked,
            })
          );

          if (closeSessionResponse?.result?.status === 200) {
            // handleClose();
            await handleClose();
          }
        } else {
          console.error("Cash out operation failed.");
        }
      } else {
        const closeSessionResponse = await dispatch(
          closePosSession({
            session_id: userData?.session_id,
            diff_amount: 0,
            counted_amount: countedCash,
            is_accept: checked,
          })
        );
        // console.log("closeSessionResponse", closeSessionResponse);

        if (closeSessionResponse?.result?.status === 200) {
          // handleClose();
          await handleClose();
        }
      }
    } catch (err) {
      console.error("Error:", err);
    } finally {
      setLoading(false);
      setIsButtonDisabled(false);
    }
  };

  // console.log("SSSSSSSSSSS", sessionDetail?.cash_difference, change);
  const collection = sessionDetail?.all_collection || {};

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 999,
        backgroundColor: "rgba(0, 0, 0, 0.5)", // fallback for blur
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 16,
        backdropFilter: "blur(6px)", // works on modern browsers
        WebkitBackdropFilter: "blur(6px)", // for Safari
      }}
      className="inset-0 flex items-center justify-center"
    >
      <div
        className={` flex flex-col pb-2 bg-white rounded-[20px] overflow-hidden ${deviceType === "tablet" ? "fixed left-20 max-w-[640px]" : "max-w-[765px] relative"
          }`}
      >
        <div
          className={`flex gap-5 pt-4 pb-1 w-full text-3xl font-semibold text-left bg-white text-zinc-800 max-md:flex-wrap ${deviceType === "tablet" ? "px-6" : "px-12"
            } max-md:px-5 max-md:max-w-full`}
        >
          <div className="flex-auto">
            {showDash == false ? t("Counted Cash") : t("Closing Summary")}
            <button
              type="button"
              onClick={closeModal}
              // className="absolute top-5 right-4 text-gray-600 hover:text-gray-700 bg-transparent"
              className={`absolute top-5 ${deviceType === "tablet" ? "right-2" : "right-12"
                } text-gray-600 hover:text-gray-700 bg-transparent`}
            >
              <svg
                xmlns=""
                className="w-8 h-8"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>
        </div>
        {showDash ? (
          <>
            <div
              className={`flex flex-col mt-4 w-full max-md:max-w-full ${deviceType === "tablet" ? "px-6" : "px-12"
                } max-md:px-5`}
            >
              <img
                loading="lazy"
                src=""
                className="mt-2 w-full border border-solid border-slate-200 stroke-[1px] stroke-slate-200 max-md:max-w-full"
              />
              <div className="flex gap-5 justify-between mt-2.5 text-base capitalize max-md:flex-wrap max-md:max-w-full">
                <div className="text-zinc-800">{t("Total Sales")}</div>
                <div className="font-semibold text-black">
                  EGP {sessionDetail?.total_earning}
                </div>
              </div>
              <img
                loading="lazy"
                src=""
                className="mt-2 w-full border border-solid border-slate-200 stroke-[1px] stroke-slate-200 max-md:max-w-full"
              />
              {/* <div className="flex gap-5 justify-between mt-2.5 text-base capitalize text-zinc-800 max-md:flex-wrap max-md:max-w-full">
                <div>{t("Total Invoices")}</div>
                <div className="font-semibold">
                  EGP {sessionDetail?.toal_invoices}
                </div>
              </div> */}
              {/* <img
                loading="lazy"
                src=""
                className="mt-2 w-full border border-solid border-slate-200 stroke-[1px] stroke-slate-200 max-md:max-w-full"
              /> */}
              <div className="flex gap-5 justify-between mt-2.5 text-base capitalize max-md:flex-wrap max-md:max-w-full">
                <div className="text-zinc-800">{t("Opening Cash")}</div>
                <div className="font-semibold text-black">
                  EGP {sessionDetail?.opening_cash}
                </div>
              </div>
              <img
                loading="lazy"
                src=""
                className="mt-2 w-full border border-solid border-slate-200 stroke-[1px] stroke-slate-200 max-md:max-w-full"
              />
              <div className="flex gap-5 justify-between mt-2.5 text-base capitalize max-md:flex-wrap max-md:max-w-full">
                <div className="text-zinc-800">{t("Cash In")}</div>
                <div className="font-semibold text-black">
                  EGP {sessionDetail?.cash_in_amt}
                </div>
              </div>
              <img
                loading="lazy"
                src=""
                className="mt-2 w-full border border-solid border-slate-200 stroke-[1px] stroke-slate-200 max-md:max-w-full"
              />
              <div className="flex gap-5 justify-between mt-2.5 text-base capitalize max-md:flex-wrap max-md:max-w-full">
                <div className="text-zinc-800">{t("Cash Out")}</div>
                <div className="font-semibold text-black">
                  EGP{" "}
                  {i18n.language === "ar" && sessionDetail?.cash_out_amt < 0
                    ? `${-sessionDetail?.cash_out_amt}-`
                    : sessionDetail?.cash_out_amt}
                </div>
              </div>
                {sessionDetail?.cash_out_summary?.length > 0 &&
  sessionDetail?.cash_out_summary.map((item, index) => (
    <div
      key={index}
      className="flex flex-row justify-between items-center"
      style={{ marginTop: "-3px", marginBottom: "-3px" }}
    >
      <div className="flex items-center gap-1">
        <span className="text-gray-700 text-2xl">•</span>
        <p className=" text-gray-700">
          {item.remark || t("Other")}
        </p>
      </div>

      <p className=" text-gray-700 ">
        {`EGP ${Number(item.amount || 0).toFixed(2)}`}
      </p>
    </div>
  ))}
              <img
                loading="lazy"
                src=""
                className="mt-2 w-full border border-solid border-slate-200 stroke-[1px] stroke-slate-200 max-md:max-w-full"
              />
              <div className="flex gap-5 justify-between mt-2.5 text-base capitalize text-zinc-800 max-md:flex-wrap max-md:max-w-full">
                <div>{t("Total No Of Orders")}</div>
                <div className="font-semibold">
                  {sessionDetail?.total_orders}
                </div>
              </div>
              <img
                loading="lazy"
                src=""
                className="mt-2 w-full border border-solid border-slate-200 stroke-[1px] stroke-slate-200 max-md:max-w-full"
              />
              {/* Dynamically render all payment method collections with the same UI as the static ones */}
              {Object.keys(collection).map((paymentMethod) => (
                <React.Fragment key={paymentMethod}>
                  <div className="flex gap-5 justify-between mt-2.5 text-base capitalize text-zinc-800 max-md:flex-wrap max-md:max-w-full">
                    <div>{`${t(paymentMethod)} ${t("Collection")}`}</div>
                    <div className="font-semibold">
                      EGP {isNaN(Number(collection[paymentMethod]))
                        ? "0.00"
                        : Number(collection[paymentMethod]).toFixed(2)}
                    </div>
                  </div>
                  <img
                    loading="lazy"
                    src=""
                    className="mt-2 w-full border border-solid border-slate-200 stroke-[1px] stroke-slate-200 max-md:max-w-full"
                  />
                </React.Fragment>
              ))}
              {/* <div className="flex gap-5 justify-between mt-2.5 text-base capitalize text-zinc-800 max-md:flex-wrap max-md:max-w-full">
                <div>{t("Collected Cash")}</div>
                <div className="font-semibold">
                  EGP {sessionDetail?.collected_cash}
                </div>
              </div>
              <img
                loading="lazy"
                src=""
                className="mt-2 w-full border border-solid border-slate-200 stroke-[1px] stroke-slate-200 max-md:max-w-full"
              />
              <div className="flex gap-5 justify-between mt-2.5 text-base capitalize text-zinc-800 max-md:flex-wrap max-md:max-w-full">
                <div>{t("Bank Collection")}</div>
                <div className="font-semibold">
                  EGP {sessionDetail?.bank_collection}
                </div>
              </div>
              <img
                loading="lazy"
                src=""
                className="mt-2 w-full border border-solid border-slate-200 stroke-[1px] stroke-slate-200 max-md:max-w-full"
              /> */}
              <div className="flex gap-5 justify-between mt-2.5 text-base capitalize text-zinc-800 max-md:flex-wrap max-md:max-w-full">
                <div>{t("Total Cash Available")}</div>
                <div className="font-semibold">
                  EGP {-sessionDetail?.cash_difference?.toFixed(2)}
                </div>
              </div>
              <img
                loading="lazy"
                src=""
                className="mt-2 w-full border border-solid border-slate-200 stroke-[1px] stroke-slate-200 max-md:max-w-full"
              />
              <div className="flex mt-5 max-md:flex-wrap max-md:max-w-full">
                <div className="flex flex-col me-5 flex-1 grow shrink-0 items-start py-2 pr-20 pl-6 bg-white rounded-2xl border border-solid basis-0 border-neutral-400 border-opacity-50 text-zinc-800 w-5/12 max-md:px-5">
                  <div className="text-base">{t("Difference")}</div>
                  <div
                    className="text-3xl mt-5 font-semibold"
                    style={{ color: change === 0 ? "green" : "red" }}
                  >
                    {countedCash === "-"
                      ? -sessionDetail?.cash_difference
                      : isNaN(change)
                        ? 0 // <--- Add this check
                        : change === 0
                          ? 0
                          : change < 0
                            ? -change?.toFixed(2)
                            : typeof change === "number" && change % 1 !== 0
                              ? i18n.language === "ar"
                                ? `${Math.abs(change)?.toFixed(2)}-`
                                : -change?.toFixed(2)
                              : i18n.language === "ar"
                                ? `${Math.abs(change)?.toFixed(2)}-`
                                : -change}
                  </div>
                </div>
                <div className="flex flex-col flex-1 grow shrink-0 items-start py-2 pr-20 pl-6 text-lg bg-white rounded-2xl border border-solid basis-0 border-neutral-400 border-opacity-50 w-5/12 max-md:px-5">
                  <div className="text-red-600">
                    <span className="text-[#7EC242]">{t("Counted Cash")}</span>{" "}
                  </div>
                  <input
                    type="text"
                    ref={countedCashRef}
                    readOnly={deviceType === "tablet"}
                    autoFocus={true}
                    className={`bg-white rounded-lg border-stone-300 h-[60px] focus:outline-none px-2 font-bold text-zinc-800 w-11/12  ${deviceType === "tablet"
                      ? "caret-zinc-800 text-3xl"
                      : "text-3xl"
                      }`}
                    value={countedCash}
                    style={{ direction: "ltr" }}
                    onFocus={() => {
                      if (deviceType === "tablet") {
                        setKeyboardMode("numeric");
                        setShowKeyboard(true);
                        setFocusedField("countedCash");
                      }
                    }}
                    onChange={(e) => {
                      let newValue = e.target.value;
                      newValue = newValue.replace(/[،ز]/g, ".");
                      if (newValue.match(/^-?\d*\.?\d{0,2}$/)) {
                        handleDiffChange(newValue);
                      }
                    }}
                    onKeyPress={handleEnterKeyPress}
                    maxLength={10}
                  />
                </div>
              </div>

              {change < 0 && (
                <>
                  <div
                    className="flex flex-row text-lg font-semibold  mt-5 cursor-pointer"
                    onClick={() => setShowSettleOptions(!showSettleOptions)}
                  >
                    {t("Settle amount by cash out")}
                    <span className="cursor-pointer">
                      <img
                        className="mt-1 ms-2 w-5 h-5"
                        src={drop_arrow_black}
                        alt="arrow"
                      />
                    </span>
                  </div>

                  {showSettleOptions && (
                    <div className="flex  mt-5 max-md:flex-wrap max-md:max-w-full justify-between">
                      <div className="flex flex-col flex-1 grow  shrink-0 items-start  bg-white rounded-2xl  w-5/12 max-md:px-5 me-4">

                        <div className="text-base">{t("Cash Out")}</div>
                      <div className="flex flex-col me-5 flex-1 grow shrink-0 items-start justify-center pr-20 pl-6 max-h-[50px] min-h-[50px]  bg-white rounded-xl border border-solid basis-0 border-neutral-400 border-opacity-50 w-full max-md:px-5">
                        <input
                          type="number"
                          value={(-cashOut)?.toFixed(2)}
                          readOnly
                          className="bg-white rounded-lg border-stone-300 h-[25px] focus:outline-none px-2 font-bold text-zinc-800 w-11/12 text-xl"
                        />
                      </div>
                      </div>

                      <div className="flex flex-col flex-1 grow  shrink-0 items-start  bg-white rounded-xl  w-5/12 max-md:px-5">
                        {/* <div className="text-base">{t("Reason")}</div> */}

                        
              <p className=" font-normal ">
                {t("Select Expense Type")}
              </p>
              <Select
                style={{
                  width: "100%",
                  backgroundColor: "white",
                  fontSize: "20px",
                  fontWeight: "bold",
                }}
                dropdownStyle={{ fontSize: "20px" }}
                placeholder={t("Select Expense Type")}
                value={expenseType}
                onChange={(value) => {
                  setExpenseType(value);
                  if (value !== "Other") {
                    setReason(value);
                    reasonRef.current = value; // <-- keep in sync
                  } else {
                    setReason("");
                    reasonRef.current = "";
                  }
                }}
                onSearch={(value) => setExpenseType(value)}
                showSearch
                filterOption={(input, option) =>
                  option.children.toLowerCase().includes(input.toLowerCase())
                }
                notFoundContent={loadingTypes ? t("Loading...") : t("")}
                className="custom-select"
                popupClassName="custom-select-dropdown"
                // onDropdownVisibleChange={(open) => {
                //   setIsDropdownOpen(isD);
                // }}
              >
                {expenseTypes.map((type) => (
                  <Option
                    style={{
                      fontSize: "20px",
                    }}
                    key={type}
                    value={type}
                    className="text-normal"
                  >
                    {t(type)}
                  </Option>
                ))}
                <Option
                  style={{
                    fontSize: "20px",
                  }}
                  key="Other"
                  value="Other"
                  className="text-normal"
                >
                  {t("Other")}
                </Option>
              </Select>
           

          { expenseType === "Other" ? (
            <InputField
              label="Reason"
              placeholder="Enter Reason"
              value={reason}
              type="text"
              // readOnly={deviceType === "tablet"} // only readOnly on tablet
              onFocus={() => {
                // if (deviceType === "tablet") {
                //   setKeyboardMode("alphanumeric");
                //   setShowKeyboard(true);
                //   setFocusedField("reason");
                // }
              }}
              focused={focusedField === "reason"}
              onEnterPress={() => {
                  handleCloseSession(reason);
              }}
              onChange={setReason}
            />
          ) : null}
                      </div>
                    </div>
                  )}
                </>
              )}
            </div>
            <div
              className={`flex self-center mb-2 mt-6 w-full text-xl font-semibold text-center capitalize max-w-[665px] max-md:flex-wrap max-md:max-w-full ${deviceType === "tablet" ? "px-6" : ""
                }`}
            >
              <button
                className="grow justify-center items-center me-5  w-3/6 py-3.5 text-[#7EC242] bg-white rounded-lg border-2 border-[#7EC242] border-solid max-md:px-5 focus:outline-none focus:ring-2 focus:ring-lime-500 focus:ring-opacity-50"
                onClick={closeModal}
              >
                {t("Continue Selling")}
              </button>
              <button
                disabled={
                  isButtonDisabled || (change !== 0 && !showSettleOptions)
                }
                style={{
                  opacity: change === 0 || showSettleOptions ? 1 : 0.5,
                }}
                onClick={()=>handleCloseSession(reason)}
                className="grow justify-center items-center  w-3/6  py-3.5 text-white bg-[#7EC242] rounded-lg max-md:px-5 focus:outline-none focus:ring-2 focus:ring-lime-500 focus:ring-opacity-50"
              >
                {loading && <LoadingSpinner />}
                {t("Close Session")}
              </button>
            </div>{" "}
          </>
        ) : (
          <>
            <div className="flex flex-col px-12 mt-4 w-full max-md:px-5 max-md:max-w-full">
              <div
                className={`flex border border-solid rounded-xl overflow-hidden justify-center items-start ${i18n.language === "ar" ? "flex-row-reverse" : ""
                  }`}
              >
                <span className=" text-2xl pl-3 pr-3 pt-[14px] bg-white  text-black max-md:pe-3 font-semibold">
                  EGP
                </span>
                <input
                  type="text"
                  ref={countedCashRef}
                  autoFocus={true}
                  className="bg-white rounded-lg border-stone-300 h-[60px] focus:outline-none px-2 font-bold text-zinc-800 w-11/12 text-3xl"
                  value={countedCash}
                  style={{ direction: "ltr" }}
                  onChange={(e) => {
                    let newValue = e.target.value;

                    newValue = newValue.replace(/[،ز]/g, ".");
                    if (newValue.match(/^-?\d*\.?\d{0,2}$/)) {
                      handleDiffChange(newValue);
                    }
                  }}
                  onKeyPress={handleEnterKeyPress}
                  maxLength={10}
                />
              </div>
              <div className="flex self-center mb-2 mt-6 w-full text-xl font-semibold text-center capitalize max-w-[665px] max-md:flex-wrap max-md:max-w-full mx-6">
                <button
                  className="grow justify-center items-center me-5  w-3/6 py-3.5 text-[#7EC242] bg-white rounded-lg border-2 border-[#7EC242] border-solid max-md:px-5 focus:outline-none focus:ring-2 focus:ring-lime-500 focus:ring-opacity-50"
                  onClick={closeModal}
                >
                  {t("Continue Selling")}
                </button>
                <button
                  // disabled={
                  //   isButtonDisabled || (change !== 0 && !showSettleOptions)
                  // }
                  style={
                    {
                      // opacity: change === 0 || showSettleOptions ? 1 : 0.5,
                    }
                  }
                  onClick={handleCloseSessionForRestrictedUser}
                  className="grow justify-center items-center  w-3/6  py-3.5 text-white bg-[#7EC242] rounded-lg max-md:px-5 focus:outline-none focus:ring-2 focus:ring-lime-500 focus:ring-opacity-50"
                >
                  {loading && <LoadingSpinner />}
                  {t("Close Session")}
                </button>
              </div>
            </div>
          </>
        )}
      </div>
      {deviceType === "tablet" && showKeyboard && (
        <AlphaNumericKeyboardModal
          onClose={() => setShowKeyboard(false)}
          width="42%"
          maxWidth="42%"
          maxHeight="54%"

          onKeyPress={(key) => {
            if (focusedField === "countedCash") {
              if (key === "DEL") {
                const updated = (countedCash || "").slice(0, -1);
                handleDiffChange(updated);
              } else {
                const newVal = (countedCash || "") + key;
                if (newVal.match(/^-?\d*\.?\d{0,2}$/)) {
                  handleDiffChange(newVal);
                }
              }
            } else if (focusedField === "reason") {
              if (key === "DEL") {
                setReason((prev) => prev.slice(0, -1));
              } else if (key === "SPACE") {
                setReason((prev) => prev + " ");
              } else {
                setReason((prev) => prev + key);
              }
            }
          }}
          mode={keyboardMode}
        />
      )}
    </div>
  );
};

export default CloseSessionModal;
